import { Badge, Card, Typography } from 'antd';
import { changeBgColor } from '../../utils/changeColor';
import React, { memo } from 'react';

const { Text } = Typography;

function ConfirmationCard({ statistic }) {
    if (!statistic) return null;
    
    return (
        <Badge.Ribbon 
            text={statistic.label} 
            color={changeBgColor(statistic.label)}
            style={{ 
                maxWidth: '80%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }}
        >
            <Card 
                style={{ 
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    textAlign: 'left',
                    height: '100%',
                    transition: 'all 0.3s ease',
                    cursor: 'default'
                }} 
                size="small"
                hoverable
            >
                <Text strong style={{ fontSize: '24px', display: 'block', marginBottom: '8px' }}>
                    {statistic.count.toString()}
                </Text>
                <Text type="secondary" style={{ fontSize: '16px' }}>
                    {`${statistic.percent} du total`}
                </Text>
            </Card>
        </Badge.Ribbon>
    );
}

ConfirmationCard.displayName = 'ConfirmationCard';

export default memo(ConfirmationCard);